function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo } from 'react';
import { HStack, Stack, Box, Hidden } from 'native-base';
import { Button, Typography } from 'fmc-digital-common';
const InfoCard = ({
  title,
  description,
  subTitle,
  firstButtonProps,
  secondButtonProps,
  icon,
  onReturnToHome,
  uploadOtherDocuments
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    borderColor: "lightBlue.400",
    borderRadius: 4,
    borderWidth: 1,
    p: {
      base: '4',
      sm: '4',
      md: '8',
      lg: '8',
      xl: '8'
    }
  }, /*#__PURE__*/React.createElement(HStack, null, /*#__PURE__*/React.createElement(Hidden, {
    till: "lg"
  }, /*#__PURE__*/React.createElement(Box, {
    alignSelf: 'center',
    marginRight: '8'
  }, icon)), /*#__PURE__*/React.createElement(Stack, {
    flex: '1'
  }, /*#__PURE__*/React.createElement(Typography, {
    color: 'darkGray.900',
    variant: 'title1',
    flex: '1',
    mb: 4
  }, title), subTitle || subTitle !== '' ? /*#__PURE__*/React.createElement(Typography, {
    variant: 'subtitle2V2',
    color: 'darkGray.900',
    mb: 4,
    mt: {
      base: undefined,
      lg: 4,
      xl: 4
    }
  }, subTitle) : null, /*#__PURE__*/React.createElement(Typography, {
    color: 'darkGray.900',
    variant: 'body16',
    flex: '1',
    mb: {
      base: 4,
      sm: 4,
      md: 8,
      lg: 8,
      xl: 8
    }
  }, description), firstButtonProps || secondButtonProps ? /*#__PURE__*/React.createElement(Stack, {
    direction: {
      base: 'column',
      md: 'row',
      lg: 'row',
      xl: 'row'
    },
    space: {
      base: '3',
      sm: '2',
      md: '3',
      lg: '3'
    }
  }, firstButtonProps ? /*#__PURE__*/React.createElement(Button, _extends({}, firstButtonProps, {
    width: {
      base: '100%',
      sm: '100%',
      md: 'container',
      lg: 'container'
    },
    onPress: onReturnToHome
  }), "RETURN TO HOME") : null, secondButtonProps ? /*#__PURE__*/React.createElement(Button, _extends({}, secondButtonProps, {
    width: {
      base: '100%',
      sm: '100%',
      md: 'container',
      lg: 'container'
    },
    onPress: uploadOtherDocuments
  }), "UPLOAD OTHER DOCUMENTS") : null) : null)));
};
export default /*#__PURE__*/memo(InfoCard);
//# sourceMappingURL=index.js.map